function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imagecaption/imagecaptionediting
 */
import { Plugin } from 'ckeditor5/src/core';
import { Element, enablePlaceholder } from 'ckeditor5/src/engine';
import { setHighlightHandling, toWidgetEditable } from 'ckeditor5/src/widget';
import { toArray } from 'ckeditor5/src/utils';
import ToggleImageCaptionCommand from './toggleimagecaptioncommand';
import ImageUtils from '../imageutils';
import { getCaptionFromImageModelElement, matchImageCaptionViewElement } from './utils';
/**
 * The image caption engine plugin. It is responsible for:
 *
 * * registering converters for the caption element,
 * * registering converters for the caption model attribute,
 * * registering the {@link module:image/imagecaption/toggleimagecaptioncommand~ToggleImageCaptionCommand `toggleImageCaption`} command.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageCaptionEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageCaptionEditing, _Plugin);

  var _super = _createSuper(ImageCaptionEditing);

  /**
   * @inheritDoc
   */
  function ImageCaptionEditing(editor) {
    var _this;

    _classCallCheck(this, ImageCaptionEditing);

    _this = _super.call(this, editor);
    /**
     * A map that keeps saved JSONified image captions and image model elements they are
     * associated with.
     *
     * To learn more about this system, see {@link #_saveCaption}.
     *
     * @member {WeakMap.<module:engine/model/element~Element,Object>}
     */

    _this._savedCaptionsMap = new WeakMap();
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ImageCaptionEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var schema = editor.model.schema; // Schema configuration.

      if (!schema.isRegistered('caption')) {
        schema.register('caption', {
          allowIn: 'imageBlock',
          allowContentOf: '$block',
          isLimit: true
        });
      } else {
        schema.extend('caption', {
          allowIn: 'imageBlock'
        });
      }

      editor.commands.add('toggleImageCaption', new ToggleImageCaptionCommand(this.editor));

      this._setupConversion();

      this._setupImageTypeCommandsIntegration();
    }
    /**
     * Configures conversion pipelines to support upcasting and downcasting
     * image captions.
     *
     * @private
     */

  }, {
    key: "_setupConversion",
    value: function _setupConversion() {
      var editor = this.editor;
      var _view = editor.editing.view;
      var imageUtils = editor.plugins.get('ImageUtils');
      var t = editor.t; // View -> model converter for the data pipeline.

      editor.conversion.for('upcast').elementToElement({
        view: function view(element) {
          return matchImageCaptionViewElement(imageUtils, element);
        },
        model: 'caption'
      }); // Model -> view converter for the data pipeline.

      editor.conversion.for('dataDowncast').elementToElement({
        model: 'caption',
        view: function view(modelElement, _ref) {
          var writer = _ref.writer;

          if (!imageUtils.isBlockImage(modelElement.parent)) {
            return null;
          }

          return writer.createContainerElement('figcaption');
        }
      }); // Model -> view converter for the editing pipeline.

      editor.conversion.for('editingDowncast').elementToElement({
        model: 'caption',
        view: function view(modelElement, _ref2) {
          var writer = _ref2.writer;

          if (!imageUtils.isBlockImage(modelElement.parent)) {
            return null;
          }

          var figcaptionElement = writer.createEditableElement('figcaption');
          writer.setCustomProperty('imageCaption', true, figcaptionElement);
          enablePlaceholder({
            view: _view,
            element: figcaptionElement,
            text: t('Enter image caption'),
            keepOnFocus: true
          });
          var widgetEditable = toWidgetEditable(figcaptionElement, writer);
          setHighlightHandling(widgetEditable, writer, function (element, descriptor, writer) {
            return writer.addClass(toArray(descriptor.classes), element);
          }, function (element, descriptor, writer) {
            return writer.removeClass(toArray(descriptor.classes), element);
          });
          return widgetEditable;
        }
      });
      editor.editing.mapper.on('modelToViewPosition', mapModelPositionToView(_view));
      editor.data.mapper.on('modelToViewPosition', mapModelPositionToView(_view));
    }
    /**
     * Integrates with {@link module:image/image/imagetypecommand~ImageTypeCommand image type commands}
     * to make sure the caption is preserved when the type of an image changes so it can be restored
     * in the future if the user decides they want their caption back.
     *
     * @private
     */

  }, {
    key: "_setupImageTypeCommandsIntegration",
    value: function _setupImageTypeCommandsIntegration() {
      var _this2 = this;

      var editor = this.editor;
      var imageUtils = editor.plugins.get('ImageUtils');
      var imageTypeInlineCommand = editor.commands.get('imageTypeInline');
      var imageTypeBlockCommand = editor.commands.get('imageTypeBlock');

      var handleImageTypeChange = function handleImageTypeChange(evt) {
        // The image type command execution can be unsuccessful.
        if (!evt.return) {
          return;
        }

        var _evt$return = evt.return,
            oldElement = _evt$return.oldElement,
            newElement = _evt$return.newElement;
        /* istanbul ignore if: paranoid check */

        if (!oldElement) {
          return;
        }

        if (imageUtils.isBlockImage(oldElement)) {
          var oldCaptionElement = getCaptionFromImageModelElement(oldElement); // If the old element was a captioned block image (the caption was visible),
          // simply save it so it can be restored.

          if (oldCaptionElement) {
            _this2._saveCaption(newElement, oldCaptionElement);

            return;
          }
        }

        var savedOldElementCaption = _this2._getSavedCaption(oldElement); // If either:
        //
        // * the block image didn't have a visible caption,
        // * the block image caption was hidden (and already saved),
        // * the inline image was passed
        //
        // just try to "pass" the saved caption from the old image to the new image
        // so it can be retrieved in the future if the user wants it back.


        if (savedOldElementCaption) {
          // Note: Since we're writing to a WeakMap, we don't bother with removing the
          // [ oldElement, savedOldElementCaption ] pair from it.
          _this2._saveCaption(newElement, savedOldElementCaption);
        }
      }; // Presence of the commands depends on the Image(Inline|Block)Editing plugins loaded in the editor.


      if (imageTypeInlineCommand) {
        this.listenTo(imageTypeInlineCommand, 'execute', handleImageTypeChange, {
          priority: 'low'
        });
      }

      if (imageTypeBlockCommand) {
        this.listenTo(imageTypeBlockCommand, 'execute', handleImageTypeChange, {
          priority: 'low'
        });
      }
    }
    /**
     * Returns the saved {@link module:engine/model/element~Element#toJSON JSONified} caption
     * of an image model element.
     *
     * See {@link #_saveCaption}.
     *
     * @protected
     * @param {module:engine/model/element~Element} imageModelElement The model element the
     * caption should be returned for.
     * @returns {module:engine/model/element~Element|null} The model caption element or `null` if there is none.
     */

  }, {
    key: "_getSavedCaption",
    value: function _getSavedCaption(imageModelElement) {
      var jsonObject = this._savedCaptionsMap.get(imageModelElement);

      return jsonObject ? Element.fromJSON(jsonObject) : null;
    }
    /**
     * Saves a {@link module:engine/model/element~Element#toJSON JSONified} caption for
     * an image element to allow restoring it in the future.
     *
     * A caption is saved every time it gets hidden and/or the type of an image changes. The
     * user should be able to restore it on demand.
     *
     * **Note**: The caption cannot be stored in the image model element attribute because,
     * for instance, when the model state propagates to collaborators, the attribute would get
     * lost (mainly because it does not convert to anything when the caption is hidden) and
     * the states of collaborators' models would de-synchronize causing numerous issues.
     *
     * See {@link #_getSavedCaption}.
     *
     * @protected
     * @param {module:engine/model/element~Element} imageModelElement The model element the
     * caption is saved for.
     * @param {module:engine/model/element~Element} caption The caption model element to be saved.
     */

  }, {
    key: "_saveCaption",
    value: function _saveCaption(imageModelElement, caption) {
      this._savedCaptionsMap.set(imageModelElement, caption.toJSON());
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [ImageUtils];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'ImageCaptionEditing';
    }
  }]);

  return ImageCaptionEditing;
}(Plugin); // Creates a mapper callback that reverses the order of `<img>` and `<figcaption>` in the image.
// Without it, `<figcaption>` would precede the `<img>` in the conversion.
//
// <imageBlock>^</imageBlock> -> <figure><img>^<caption></caption></figure>
//
// @private
// @param {module:engine/view/view~View} editingView
// @returns {Function}


export { ImageCaptionEditing as default };

function mapModelPositionToView(editingView) {
  return function (evt, data) {
    var modelPosition = data.modelPosition;
    var parent = modelPosition.parent;

    if (!parent.is('element', 'imageBlock')) {
      return;
    }

    var viewElement = data.mapper.toViewElement(parent); // The "img" element is inserted by ImageBlockEditing during the downcast conversion via
    // an explicit view position so the "0" position does not need any mapping.

    data.viewPosition = editingView.createPositionAt(viewElement, modelPosition.offset + 1);
  };
}